<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <div class="card-client-menu">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card-client-menu {
  backdrop-filter: blur(2px);
  background-color: rgba($color-tooltip-calendar-bg-wo-rgb, 0.9);
  border-radius: $base-border-radius-md;
  color: white;
  display: flex;
  font-weight: bold;
  letter-spacing: 0.108333px;
  line-height: 2rem;
  margin-bottom: 0.8rem;
  // margin-left: 0.5rem;
  margin-top: 0.8rem;
  min-width: 17%;
  overflow: visible;
  position: absolute;
  width: 100%;
  z-index: 2;

  ul {
    margin-bottom: 0;
  }
}
</style>
